<input
    type="text"
    class="form-control"
    [placement]="popoverPos"
    value="{{ defaultDate | date: 'dd.MM.yyyy' }}"
    #popoverRef="bs-popover"
    [popover]="popTemplate"
    [container]="'body'"
    [containerClass]="'popover-without-spacing'"
    [outsideClick]="true"
/>

<ng-template #popTemplate class="custom-popover-position">
    <bs-datepicker-inline
        [bsValue]="bsInlineValue"
        [minDate]="minDate"
        [bsConfig]="datePickerConfig"
        (bsValueChange)="dateSelectionDone($event)"
    >
    </bs-datepicker-inline>
</ng-template>
